import { formatMultidDate } from "@/lib/Util";

export function formateMultidDate(value: string) {
  if (value) {
    return formatMultidDate(value);
  }
  return;
}